import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import {
  AutheticationService,
  Client,
  CommonService,
  ProductsService,
  ServiceTaxiService,
  StateService,
  UsersService,
  WsService,
  CustomTranslationService
} from '@app/shared';
import { MatSnackBar } from '@angular/material';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { FormControl, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import getToken from '@app/utils/get-token';
import { tap, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

@Component({
  selector: 'app-authentification',
  templateUrl: './authentification.component.html',
  styleUrls: ['./authentification.component.scss']
})
export class AuthentificationComponent implements OnInit {
  password;
  login;
  acceptCode = new FormControl('', [Validators.maxLength(6), Validators.minLength(6)]);
  checked = false;

  authenticaiton$: Subscription;

  constructor(
    private auth: AutheticationService,
    private router: Router,
    private ws: WsService,
    public snackBar: MatSnackBar,
    private service: ServiceTaxiService,
    private product: ProductsService,
    private users: UsersService,
    private state: StateService,
    private client: Client,
    private common: CommonService,
    private cookieService: CookieService,
    private customTranslationService: CustomTranslationService
  ) {}

  ngOnInit() {}

  authenticaiton() {
    let Obj: {
      name: string;
      password: string;
      otp?: any;
    } = {
      name: this.login,
      password: this.password
    };
    let token = getToken(this.cookieService);

    if (!!token) {
      // if already authed
      forkJoin(
        this.service.getService(),
        this.product.getProducts(),
        this.common.getMenu(),
        this.customTranslationService.getListOfLanguages(),
        this.customTranslationService.getListOfTranslations()
      ).subscribe(([res1, res2, res3, custLangs, custTrans]) => {
        this.state.setParameter('services', res1.data);
        this.state.setParameter('products', res2.data);
        this.state.setParameter('authStatus', true);
        this.state.setParameter('userLogin', Obj.name);
        this.auth.auth.next(true);
        this.ws.create(this.client.getWs(), true);
        console.log(res3);

        this.customTranslationService.langs = custLangs;
        this.customTranslationService.translations = custTrans;

        this.router.navigate(['/' + res3['data'][0]['link']]);
      });
    } else {
      if (this.acceptCode.valid && this.acceptCode.value.length > 0) {
        Obj.otp = this.acceptCode.value;
      }

      this.auth
        .authUser(Obj)
        .pipe(
          tap(res => {
            this.auth.setToken(res.access_token);
          }),
          mergeMap(res => {
            return forkJoin(this.service.getService(), this.product.getProducts(), this.common.getMenu());
          }),
          catchError(err => {
            console.log('​AuthentificationComponent -> authenticaiton -> err', err);
            this.checked = err.error.errors.otp !== undefined;
            if (err.error.errors.otp !== undefined) {
              this.handleServiceError('Авторизация ', err.error.errors.otp);
              this.acceptCode.reset();
            } else {
              this.handleServiceError('Авторизация ', err.error.errors.name || err.error.errors.password);
            }
            return of(err);
          })
        )
        .subscribe(([res1, res2, res3, custLangs, custTrans]) => {
          this.state.setParameter('services', res1.data);
          this.state.setParameter('products', res2.data);
          this.state.setParameter('authStatus', true);
          this.state.setParameter('userLogin', Obj.name);
          this.auth.auth.next(true);
          this.ws.create(this.client.getWs(), true);

          this.customTranslationService.langs = custLangs;
          this.customTranslationService.translations = custTrans;

          this.router.navigate(['/' + res3['data'][0]['link']]);
        });
    }
  }

  onChange() {
    if (this.acceptCode.valid && this.acceptCode.value.length > 0) {
      this.authenticaiton();
    }
  }

  private handleServiceError(op: string, err: any) {
    let message = err;
    let action = 'close';
    this.snackBar.open(`${op} - ${message || err}`, action, {
      duration: 3000,
      extraClasses: ['error-msg'],
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/authentification/authentification.component.ts